import React, { useState } from "react";

const ExceptionalHoursModal = ({ isOpen, onClose, onAdd, trener }) => {
  const [data, setData] = useState("");
  const [godzinaStart, setGodzinaStart] = useState("");
  const [godzinaKoniec, setGodzinaKoniec] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const exceptionalHours = {
      data,
      godzina_start: godzinaStart,
      godzina_koniec: godzinaKoniec,
    };
    onAdd(trener._id, exceptionalHours); // Pass the trainer ID along with the exceptional hours
  };

  if (!isOpen) return null; // Don't render anything if the modal is not open

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div
        className="fixed inset-0 bg-black opacity-50"
        onClick={onClose}
      ></div>
      <div className="bg-white rounded-lg shadow-lg p-8 z-10 w-[480px] max-h-[80vh] overflow-y-auto">
        <h2 className="text-2xl font-bold mb-6">
          Dodaj Wyjątkowe Godziny dla {trener.imie} {trener.nazwisko}
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block mb-2">Data:</label>
            <input
              type="date"
              value={data}
              onChange={(e) => setData(e.target.value)}
              required
              className="border border-gray-300 rounded-md p-2 w-full"
            />
          </div>
          <div className="mb-4">
            <label className="block mb-2">Godzina Start:</label>
            <input
              type="time"
              value={godzinaStart}
              onChange={(e) => setGodzinaStart(e.target.value)}
              required
              className="border border-gray-300 rounded-md p-2 w-full"
            />
          </div>
          <div className="mb-4">
            <label className="block mb-2">Godzina Koniec:</label>
            <input
              type="time"
              value={godzinaKoniec}
              onChange={(e) => setGodzinaKoniec(e.target.value)}
              required
              className="border border-gray-300 rounded-md p-2 w-full"
            />
          </div>
          <div className="flex justify-end">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-300 text-black px-4 py-2 rounded mr-2"
            >
              Anuluj
            </button>
            <button
              type="submit"
              className="bg-blue-500 text-white px-4 py-2 rounded"
            >
              Dodaj
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ExceptionalHoursModal;
